module.exports = __webpack_public_path__ + "img/blue_035.67765f88.png";